import {FormCardSection} from '@/components/ui/form-atoms/FormAtoms'
import {GridItem} from '@/components/ui/grid-atoms/GridAtoms'
import {Text} from '@/components/ui/text/Text'
import {formatDate} from '@/dayjs'
import {ProjectByPatient} from '@/features/projects/types'
import {projectSectorToLabel, projectTypeToLabel} from '@/features/projects/utils'
import {useTranslation} from '@/translations/i18n'

export const ProjectOverviewCard = ({
    project
}: {
    project: Pick<ProjectByPatient, 'id' | 'code' | 'type' | 'sector' | 'durationDays' | 'expirationDate'>
}) => {
    const {t} = useTranslation()

    return (
        <FormCardSection columns={4} gap={2} padding={3}>
            <GridItem direction="column">
                <Text palette="neutral" shade="500" size="textSm">
                    {t('commons:project_type')}
                </Text>
                <Text size="textSm" weight={500}>
                    {project.type ? t(projectTypeToLabel[project.type]) : '-'}
                </Text>
            </GridItem>
            <GridItem direction="column">
                <Text palette="neutral" shade="500" size="textSm">
                    {t('commons:intervention_mode')}
                </Text>
                <Text size="textSm" weight={500}>
                    {t(projectSectorToLabel[project.sector])}
                </Text>
            </GridItem>
            <GridItem direction="column">
                <Text palette="neutral" shade="500" size="textSm">
                    {t('commons:project_duration')}
                </Text>
                <Text size="textSm" weight={500}>
                    {project.durationDays}
                </Text>
            </GridItem>
            <GridItem direction="column">
                <Text palette="neutral" shade="500" size="textSm">
                    {t('commons:expiration')}
                </Text>
                <Text size="textSm" weight={500}>
                    {project.expirationDate ? formatDate(project.expirationDate, 'DD/MM/YYYY') : '-'}
                </Text>
            </GridItem>
        </FormCardSection>
    )
}
